import { Component, Inject, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { isPlatformBrowser, NgClass } from '@angular/common';
import { ClearCartInfoComponent } from "./common-resource/component/clear-cart-info/clear-cart-info.component";
import { CustomToasterComponent } from "./common-resource/component/custom-toaster/custom-toaster.component";
import { SeoDataService } from './common-resource/services/seo-data.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ClearCartInfoComponent, CustomToasterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  router = inject(Router)
  title = 'finkup-ticket-private-event';
  isBrowser:boolean = false;isLoaderVisible:boolean = false
  constructor(
    private seoService:SeoDataService,
    @Inject(PLATFORM_ID) private platformId:any
  ){
    this.isBrowser = isPlatformBrowser(platformId);
  }
  ngOnInit(): void {
    if(environment.isSeoRequired){
      this.addScript()
    }
    this.router.events.subscribe(
      event => {
        if (event instanceof NavigationStart) {

          this.isLoaderVisible = true;
        } else if(event instanceof NavigationEnd||
                  event instanceof NavigationCancel ||
                  event instanceof NavigationError) {
          this.isLoaderVisible = false;
        }
      },
      () => {
        this.isLoaderVisible = false;
      }
    );
  }
   addScript(){
     // GTM
    this.seoService.appendScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyBpQyZIEuopLQ3etOS-_8ujMocu1TK_yow&libraries=places&language=en', true);
    this.seoService.appendScript('https://www.googletagmanager.com/gtag/js?id=G-PXKW2WRLK8', true);

    this.seoService.appendInlineScript(`
      window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-PXKW2WRLK8');`);
    

    this.seoService.appendScript('')

    this.seoService.appendInlineScript(`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-5CFP29T');`);

    this.seoService.appendInlineScript(`
      (function(n,i,t,r,o) {
      var a,m;n['NitroObject']=o;n[o]=n[o]||function(){
      (n[o].q=n[o].q||[]).push(arguments)},n[o].l=1*new Date();n[o].h=r;a=i.createElement(t),
      m=i.getElementsByTagName(t)[0];a.async=1;a.src=r;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://x.nitrocommerce.ai/nitro.js','nitro');
      nitro('configure', '19e2c2ff-0fc4-4c26-8888-a0b54af5449b');`)

    this.seoService.appendInlineScript(`
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PPDB742Z');`);

    // meta pixel code
    this.seoService.appendInlineScript(`
      !function(f,b,e,v,n,t,s){
      if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1071789651379467');
      fbq('track', 'PageView');
    `);

     // Add <noscript> fallbacks
    this.seoService.addNoScript(`
      <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=1071789651379467&ev=PageView&noscript=1"/>`);
    // GTM <noscript>
    this.seoService.addNoScript(`<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5CFP29T"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`);
    this.seoService.addNoScript(`<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PPDB742Z"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`);

    this.seoService.appendScript('https://checkout.razorpay.com/v1/checkout.js', true);

  }

}
